"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendNewRelicEvent = void 0;
const config_1 = require("./config");
const js_cookie_1 = __importDefault(require("js-cookie"));
function sendNewRelicEvent(eventData) {
    const env = process.env.CHEGG_ENV || 'test';
    const nrAccount = env === 'prod' ? '501356' : '501278';
    const nrKey = env === 'prod'
        ? 'NRII-Mi0ZOVEe_ofN3PNkKFbYnXl2rhtskKKD'
        : 'NRII-NKhYYYt2U1KUxYFcGdb4NKCia61dtujg';
    const url = `https://insights-collector.newrelic.com/v1/accounts/${nrAccount}/events`;
    const location = typeof window != 'undefined' ? window.location : null;
    const data = Object.assign({ env, eventType: 'OneAuthSdkEvent', clientId: config_1.getClientId(), domain: config_1.getCookieDomain(), website: location === null || location === void 0 ? void 0 : location.host, path: location === null || location === void 0 ? void 0 : location.pathname, callTimestamp: Date.now(), sessionId: js_cookie_1.default.get('CSessionID'), userAgent: typeof window !== 'undefined' ? window.navigator.userAgent : 'unknown', url: typeof window !== 'undefined' ? window.location.href : 'unknown' }, eventData);
    const nrEventBody = JSON.stringify(data);
    return fetch(url, {
        method: 'POST',
        cache: 'no-cache',
        headers: {
            'Content-Type': 'application/json',
            'X-insert-Key': nrKey,
        },
        body: nrEventBody,
    });
}
exports.sendNewRelicEvent = sendNewRelicEvent;
